const GenerateImage = () => {
    return (
        <iframe
            src="/image-generator.html"
            style={{ width: "100%", height: "100vh", border: "none" }}
            title="Gerador de Assinaturas"
        />
    );
};

export default GenerateImage;